import { Button, ButtonProps } from '@billy/design-system'
import React from 'react'

export const ToggleDeletionModeButton = (props: ButtonProps) => (
  <Button {...props} icon="trash" size="sm" variant="text" />
)
